import React, { useState, useEffect, useRef } from 'react';
import axios from "axios";
import Header from '../../Header';
import Footer from '../../Footer';
import 'datatables.net-bs5/css/dataTables.bootstrap5.min.css';
import $ from 'jquery';
import 'datatables.net-bs5';
import { Link } from 'react-router-dom';
import CommonDatePicker from '../../datepicker/CommonDatePicker';
import 'rsuite/dist/rsuite.min.css';
import { API_URL, BASE_URL } from '../../Config';
import AddUsers from './AddUsers';
import config from "../../common/Config";
import Swal from 'sweetalert2';
import ExportUserList from './ExportUserList';
import { setTableWidths, getTableWidths } from "../../../data/postAPi";

const Users = () => {

  const userTableRef = useRef(null);
  const [searchValue, setSearchValue] = useState([]);
  const accessToken = localStorage.getItem('accessToken');
  const [totalUsers, setTotalUsers] = useState('');
  const [colWidths, setColWidths] = useState([50, 100, 120, 120, 200, 150, 150, 100, 120]);
  const userId = localStorage.getItem("userId");
  const tableName = "usersTable";

  function debounce(func, wait) {
    let timeout;
    return function (...args) {
      clearTimeout(timeout);
      timeout = setTimeout(() => func.apply(this, args), wait);
    };
  }

  const debouncedSetTableWidths = useRef(
    debounce((userId, tableName, widths) => {
      setTableWidths(userId, tableName, widths);
    }, 500)
  ).current;

  function startResizing(index, e) {
    e.preventDefault();
    const startX = e.clientX;
    const startWidth = colWidths[index];
    const onMouseMove = (moveEvent) => {
      const newWidth = Math.max(30, startWidth + moveEvent.clientX - startX);
      setColWidths((widths) => {
        const updated = [...widths];
        updated[index] = newWidth;
        debouncedSetTableWidths(userId, tableName, updated);
        return updated;
      });
    };
    const onMouseUp = () => {
      document.removeEventListener("mousemove", onMouseMove);
      document.removeEventListener("mouseup", onMouseUp);
    };
    document.addEventListener("mousemove", onMouseMove);
    document.addEventListener("mouseup", onMouseUp);
  }

  const fetchWidths = async () => {
    try {
      const res = await getTableWidths(userId, tableName);
      if (res?.data?.widths && Array.isArray(res.data.widths) && res.data.widths.length > 0) {
        setColWidths(res.data.widths);
      } else {
        setColWidths([50, 100, 120, 120, 200, 150, 150, 100, 120]);
      }
    } catch (e) {
      setColWidths([50, 100, 120, 120, 200, 150, 150, 100, 120]);
    }
  };

  const initializeCustomerTable = () => {
    const $table = $(userTableRef.current);
    const searchValue = $('#searchValue').val();
    // Destroy existing DataTable instance if it exists
    if ($.fn.DataTable.isDataTable($table)) {
      $table.DataTable().destroy();
    }

    let i = 0;
    $table.DataTable({
      processing: true,
      serverSide: true,
      ajax: {
        url: `${config.API_URL}/get_users_list`,
        type: 'POST',
        headers: {
          authorization: `Bearer ${accessToken}`,
        },
        data: function (d) {
          return $.extend({}, d, {
            draw: d.draw,
            start: d.start,
            length: d.length,
            searchValue: searchValue
          });
        },
        dataSrc: function (json) {
          setTimeout(fetchWidths, 0);
          if (json && json.data && Array.isArray(json.data)) {
            setTotalUsers(json.recordsFiltered);
          }
          return Array.isArray(json.data) ? json.data : [];
        }
      },
      language: {
        paginate: {
          first: 'First',
          last: 'Last',
          next: 'Next',
          previous: 'Previous',
        },
        search: 'Search:',
      },
      columns: [
        {
          data: null,
          width: colWidths[0] + 'px',
          render: function (data, type, row, meta) {
            return meta.row + meta.settings._iDisplayStart + 1;
          },
        },
        { data: 'username', width: colWidths[1] + 'px' },
        {
          data: null,
          width: colWidths[2] + 'px',
          render: function (data, type, row) {
            return `<span>${row.first_name}</span>`;
          }
        },
        {
          data: null,
          width: colWidths[3] + 'px',
          render: function (data, type, row) {
            return `<span>${row.last_name}</span>`;
          }
        },
        {
          data: null,
          width: colWidths[4] + 'px',
          render: function (data, type, row) {
            return `<span class="text-lowercase">${row.email.toLowerCase()}</span>`;
          }
        },
        {
          data: null,
          width: colWidths[5] + 'px',
          render: function (data, type, row) {
            return `<span>${row.name}</span>`;
          }
        },
        { data: 'roles', width: colWidths[6] + 'px' },
        {
          data: null,
          width: colWidths[7] + 'px',
          render: function (data, type, row) {
            const checked = row.active == '1' ? "checked" : "";
            return `<label class="switch" style="margin: 0px auto;">
                      <input data-id="${row.id}" class="switch-input" type="checkbox" name="changeStatus" id="changeStatus_${row.id}" ${checked} />
                      <span class="switch-label" data-on="Active" data-off="Inactive"></span>
                      <span class="switch-handle"></span>
                    </label>`;
          }

        },
        {
          data: null,
          title: 'Action',
          width: colWidths[8] + 'px',
          render: (data, type, row) => `
            <a href="${config.BASE_URL}/user/edit_profile/${row.id}" class="icon editbtn" title="Edit" >
                  <i class="fa fa-pencil"></i>
                </a>
                <a href="${config.BASE_URL}/settings/change_permissions/${row.id}" class="icon editbtn" title="Edit" >
                  <i class="fa fa-cog"></i>
                </a>
            `
        }

      ],
      columnDefs: [
        {
          orderable: false,
          targets: '_all'
        },
        {
          targets: 2,
          render: function (data) {
            return data === '1' ? 'Active' : 'Inactive';
          }
        }
      ],

      pageLength: 50,
      drawCallback: function () {
        const resizers = document.querySelectorAll('#userListTable .th-resizer');
        resizers.forEach((resizer, index) => {
          const handleMouseDown = (e) => {
            e.preventDefault();
            e.stopPropagation();
            e.stopImmediatePropagation();
            startResizing(index, e);
          };
          resizer.addEventListener('mousedown', handleMouseDown);
          resizer._resizerHandler = handleMouseDown;
        });
        $('#userListTable thead th').each(function(idx) {
          $(this).css('width', colWidths[idx] + 'px');
        });
      }
    });


    $table.on('change', '.switch-input', function () {
      const id = $(this).data('id');
      const status = this.checked ? 1 : 0;

      handleChangeStatus(id, status);
    });
  };

  const handleChangeStatus = async (id, status) => {
    const formData = new FormData();
    formData.append('status', status);
    formData.append('id', id);
    const apiUrl = `${config.API_URL}/update_users_status`;
    try {
      const response = await fetch(apiUrl, {
        method: 'POST',
        headers: {
          authorization: `Bearer ${accessToken}`,
        },
        body: formData,
      });

      if (!response.ok) {
        throw new Error('Failed to change status');
      }

      const data = await response.json();
      console.log(data);

      Swal.fire({
        title: 'Success',
        text: 'Status changed successfully.',
        icon: 'success',
        showConfirmButton: false,
        timer: 1500,
      });

    } catch (error) {
      console.error('Error status change:', error);
    }
  }


  useEffect(() => {
    if (accessToken === null) {
      window.location.href = `${config.BASE_URL}/login`;
      return;
    }
    initializeCustomerTable();
    return () => {
      if (userTableRef.current && $.fn.DataTable.isDataTable(userTableRef.current)) {
        $(userTableRef.current).DataTable().destroy();
      }
    };
  }, [searchValue]);


  const handleUserAdded = () => {
    initializeCustomerTable(); // Call this after a user is added
  };

  const resizerStyles = `
    .th-resizer:hover {
      background-color: rgba(0, 0, 0, 0.3) !important;
    }
    .resizable-header {
      position: relative;
      user-select: none;
    }
  `;

  useEffect(() => {
    const styleSheet = document.createElement('style');
    styleSheet.textContent = resizerStyles;
    document.head.appendChild(styleSheet);
    return () => {
      if (document.head.contains(styleSheet)) {
        document.head.removeChild(styleSheet);
      }
    };
  }, []);

  return (

    <div>



      <AddUsers onUserAdded={handleUserAdded} />

      <Header />

      <div class="breadcrumbs">
        <div class="container-fluid">
          <div class="row">
            <div class="col-12 col-lg-12 col-sm-12">
              <a href="#"><i class="fa fa-home"></i></a> &gt;
              <a href="Dashboard">Master</a> &gt;
              <span class="last-crumb">Users</span>
            </div>
          </div>
        </div>
      </div>

      <div className="main-container">
        <div className="container-fluid">
          <div className="row">
            <div className="col-12 col-lg-12 col-sm-12">
              <div style={{ position: 'relative' }}>
                <div class="row">
                  <div class="col-12 col-lg-4 col-sm-4"></div>
                  <div class="col-12 col-lg-8 col-sm-8">
                    <div style={{ float: "right", width: "200px" }}>
                      <a href="#" className="create-catalogue-btn" data-bs-toggle="modal" data-bs-target="#add-user" style={{ marginLeft: "10px" }}>Add User</a>
                      <ExportUserList totalUsers={totalUsers} urlLink="get_users_list" style={{ float: "left" }} />
                    </div>
                  </div>
                </div>
                <div className="show-order-area dashboard">

                  <div className="verical-scrl-wrapper common-table users-table" id="style-3">
                    <table className="table table-bordered dataTable resizable" id="userListTable" ref={userTableRef} >
                      <thead>
                        <tr>
                          {["Sr.No", "User Name", "First Name", "Last Name", "Email", "Default Role", "Multiple Role", "Status", "Actions"].map((header, idx) => (
                            <th
                              key={header}
                              className="resizable-header"
                              style={{
                                width: colWidths[idx],
                                minWidth: 50,
                                position: "relative",
                                padding: "8px"
                              }}
                            >
                              {header}
                              {idx < colWidths.length - 1 && (
                                <div
                                  className="th-resizer"
                                  data-column-index={idx}
                                  title="Drag to resize column"
                                  style={{
                                    position: 'absolute',
                                    right: '-2px',
                                    top: 0,
                                    width: '5px',
                                    height: '100%',
                                    cursor: 'col-resize',
                                    zIndex: 999,
                                    userSelect: 'none'
                                  }}
                                />
                              )}
                            </th>
                          ))}
                        </tr>
                      </thead>
                      <tbody>

                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <Footer />
      </div>

    </div>
  );
};

export default Users; 